import { DatabaseCode, toDatabaseCode } from "./database-code";

/**
 * The status of a dispatch request.
 */
export interface DispatchStatus extends DatabaseCode {
}

const pending: DispatchStatus = {
  code: "Pending",
  displayValue: {
    id: "ots.ui.entity.dispatch.status.pending",
    defaultMessage: "Pending"
  }
};

const canceled: DispatchStatus = {
  code: "Canceled",
  displayValue: {
    id: "ots.ui.entity.dispatch.status.canceled",
    defaultMessage: "Canceled"
  }
};

const started: DispatchStatus = {
  code: "Started",
  displayValue: {
    id: "ots.ui.entity.dispatch.status.started",
    defaultMessage: "Started"
  }
};

const completed: DispatchStatus = {
  code: "Completed",
  displayValue: {
    id: "ots.ui.entity.dispatch.status.completed",
    defaultMessage: "Completed"
  }
};

export const dispatchStatus = {
  pending,
  canceled,
  completed,
  started
};

export const dispatchStatuses = Object.values(dispatchStatus);

export const toDispatchStatus = (code: string): DispatchStatus => toDatabaseCode(code, dispatchStatuses);
